import { createContext, useContext } from 'react';

interface SkipGlobalFiltersContextValue {
  skipGlobalFilters: boolean;
}

const SkipGlobalFiltersContext = createContext<SkipGlobalFiltersContextValue>({
  skipGlobalFilters: false,
});

export function SkipGlobalFiltersProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <SkipGlobalFiltersContext.Provider value={{ skipGlobalFilters: true }}>
      {children}
    </SkipGlobalFiltersContext.Provider>
  );
}

export function useSkipGlobalFiltersContext() {
  return useContext(SkipGlobalFiltersContext);
}
